/**
 * 病気一覧
 */
export const ABSENCE_REASON_DETAIL_SICK_TYPE = [
  '熱',
  '咳',
  '鼻水',
  '腹痛',
  '嘔吐',
  '下痢',
  '静養',
  '中耳炎',
  '眼症状',
  '気管支炎',
  'ケガ',
  '皮膚症状',
  '入院',
  '川崎病',
  'その他',
] as const;

/** 病気 */
export type AbsenceReasonDetailSickType = typeof ABSENCE_REASON_DETAIL_SICK_TYPE[number];
